import type React from "react";

import {OverlayPortalProvider} from "@project/components/overlays/overlay-portal-context";
import {UNSAFE_PortalProvider} from "@react-aria/overlays";
import {useRef} from "react";

interface ChromeOverlayProviderProps {
  children: React.ReactNode;
}

export function ChromeOverlayProvider({children}: ChromeOverlayProviderProps) {
  const chromeOverlayRef = useRef<HTMLDivElement>(null);

  return (
    <OverlayPortalProvider getContainer={() => chromeOverlayRef.current}>
      <UNSAFE_PortalProvider getContainer={() => chromeOverlayRef.current}>
        {children}
        <div
          ref={chromeOverlayRef}
          className="pointer-events-none fixed inset-0 z-1000 *:pointer-events-auto"
          data-react-aria-top-layer="true"
          id="chrome-overlay-root"
        />
      </UNSAFE_PortalProvider>
    </OverlayPortalProvider>
  );
}
